export { default } from './special-offers-chip';
